import { Table, TableHeader, TableRow, TableCell, TableBody, TableHead } from "V2.0/common/table";
import { campaignObjectColumns } from "./CampaignObjectsTable";

// Old hardcoded 5-column/20-row skeleton. Replaced below with a generic version driven by props so
// the bulk-campaign drill-down page (Task 6) can pass campaignObjectColumns({hideAssistant:true}) and
// its own row count, and render without the fixed-height scroll wrapper when it manages its own
// layout. (bulk-campaign-report-ui-port, Task 6)
// export default function CampaignsLoading() {
//   return (
//     <div className="h-[72dvh]">
//       <div className="h-[68dvh] overflow-scroll">
//         <Table className="animate-pulse">
//           <TableHead>
//             <TableRow>
//               <TableHeader>Campaign</TableHeader>
//               <TableHeader>Assistant</TableHeader>
//               <TableHeader>Follow Up</TableHeader>
//               <TableHeader>Created At</TableHeader>
//               <TableHeader>Action</TableHeader>
//             </TableRow>
//           </TableHead>
//
//           <TableBody>
//             {Array.from({ length: 20 }).map((_, index) => (
//               <TableRow key={index}>
//                 <TableCell>
//                   <div className="h-6 bg-gray-100 rounded"></div>
//                 </TableCell>
//                 <TableCell>
//                   <div className="h-6 bg-gray-100 rounded"></div>
//                 </TableCell>
//                 <TableCell>
//                   <div className="h-6 bg-gray-100 rounded"></div>
//                 </TableCell>
//                 <TableCell>
//                   <div className="h-6 bg-gray-100 rounded"></div>
//                 </TableCell>
//                 <TableCell>
//                   <div className="h-6 bg-gray-100 rounded"></div>
//                 </TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>
//       </div>
//     </div>
//   );
// }

export default function CampaignsLoading({
  columns,
  rows = 20,
  constrainHeight = true,
}: any = {}) {
  const headers = columns ?? campaignObjectColumns();

  const table = (
    <Table className="animate-pulse">
      <TableHead>
        <TableRow>
          {headers.map((label) => (
            <TableHeader key={label}>{label}</TableHeader>
          ))}
        </TableRow>
      </TableHead>

      <TableBody>
        {Array.from({ length: rows }).map((_, index) => (
          <TableRow key={index}>
            {headers.map((label) => (
              <TableCell key={label}>
                <div className="h-6 bg-gray-100 rounded"></div>
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );

  if (!constrainHeight) return table;

  return (
    <div className="h-[72dvh]">
      <div className="h-[68dvh] overflow-scroll">{table}</div>
    </div>
  );
}
